export var GEOCODER_SEARCH_START = 'GEOCODER_SEARCH_START';
export var GEOCODER_SEARCH_DONE = 'GEOCODER_SEARCH_DONE';
export var GEOCODER_POIS_SEARCH_DONE = 'GEOCODER_POIS_SEARCH_DONE';
export var GEOCODER_SEARCH_FAIL = 'GEOCODER_SEARCH_FAIL';
export var GEOCODER_SELECT_START = 'GEOCODER_SELECT_START';
export var GEOCODER_SELECT_DONE = 'GEOCODER_SELECT_DONE';
export var GEOCODER_SELECT_FAIL = 'GEOCODER_SELECT_FAIL';
export var GEOCODER_CLEAR_START = 'GEOCODER_CLEAR_START';
export var GEOCODER_CLEAR_DONE = 'GEOCODER_CLEAR_DONE';